'use client'
import React, { useRef, useEffect } from 'react'
import { Hero, Footer } from '../../../components'
import styles from './termofservice.module.css'
import { termsofservicetitles, alltermsofservice } from '../../../utils'

const TermOfService = () => {
  const itemRefs = useRef([])

  useEffect(() => {
    if (window.location.hash) {
      const hash = window.location.hash.substring(1)
      const index = helpcentertitle.findIndex(
        (item) => item.title.toLowerCase().split(' ').join('-') === hash
      )
      if (index !== -1 && itemRefs.current[index]) {
        itemRefs.current[index].scrollIntoView({
          behavior: 'smooth',
        })
      }
    }
  }, [])

  const handleClick = (title, index) => {
    const formattedTitle = title.toLowerCase().split(' ').join('-')
    window.location.hash = `#${formattedTitle}`
    itemRefs.current[index].scrollIntoView({
      behavior: 'smooth',
    })
  }

  return (
    <div className={styles.termofservicecontainer}>
      <Hero className={styles.innercontent}>
        <button className={styles.herobtn}>term of service</button>
        <p className={styles.herotitle}>CirclePlug Term of Service</p>
        <p className={styles.herodescription}>
          We care about your privacy Your privacy is important to us
        </p>
      </Hero>
      <div className={styles.maincontentcontainer}>
        <div>
          <div className={styles.maincontentcontainerwrapper}>
            <div className={styles.termsofservicemaincontent}>
              <div className={styles.termsofservicemaincontenttop}>
                <p>About CirclePlug</p>
                <p>
                  {`The products and services ("the services") that Shypes
                  Integrated Service Ltd. builds help individuals connect with
                  one another, create communities, and expand their businesses.
                  CirclePlug is a flagship product of Shypes Integrated Service
                  Ltd. Except where we specify otherwise, these terms govern
                  your use of CirclePlug and any other associated products,
                  features, apps, services, technologies, and software that we
                  provide. CirclePlug ("our," "we," or "us") is provided to you
                  by Shypes Integrated Services, Ltd.`}
                </p>
              </div>
              <div className={styles.termsofservicemaincontenttop}>
                <p>Agreement</p>
                <p>
                  {`The terms "you" and "your" as used in these Terms refer to the
                  entity in question if you are accepting these Terms and using
                  the Services on behalf of a company, group of people,
                  governmental body, or other legal entity. In that case, you
                  represent and warrant that you are qualified to do so and have
                  the authority to bind the relevant entity to these terms.`}
                  <br />
                  These terms, as may be amended from time to time, apply
                  entirely to use of CirclePlug.
                </p>
              </div>
              <div className={styles.termsofservicemaincontentbottom}>
                <div className={styles.termsofservicemaincontentbottomleft}>
                  <ul className={styles.termslists}>
                    {termsofservicetitles.map(({ id, title }, index) => (
                      <li
                        key={id}
                        className={styles.termlist}
                        onClick={() => handleClick(title, index)}
                      >
                        {title}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className={styles.termsofservicemaincontentbottomright}>
                  {alltermsofservice.map(({ ...rest }, index) => (
                    <div
                      key={rest.id}
                      className={styles.services}
                      ref={(item) => (itemRefs.current[index] = item)}
                    >
                      <p className={styles.servicetitle}>{rest.title}</p>
                      <p className={styles.servicedescription}>
                        {rest.description}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className={styles.emptycontent}></div>
          <div>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermOfService
